var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInstaCommentIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 15,
    viewBox: "0 0 14 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5809 11.2764C13.4723 10.0957 14 8.625 14 7.03125C14 3.14941 10.8664 0 7 0C3.13359 0 0 3.14941 0 7.03125C0 10.9131 3.13359 14.0625 7 14.0625C7.99805 14.0625 8.94688 13.8516 9.80547 13.4766L12.9883 14.9385C13.0895 14.9854 13.1934 15 13.3027 15C13.6883 15 14 14.666 14 14.2529C14 14.127 13.9699 14.0039 13.9152 13.8955L12.5809 11.2764ZM11.5609 10.3916C11.2273 10.834 11.1754 11.4492 11.4297 11.9502L11.9219 12.9199L10.3223 12.1846C9.99961 12.0352 9.6332 12.0322 9.30781 12.1758C8.60508 12.4834 7.82578 12.6562 7.00273 12.6562C3.78164 12.6562 1.31523 10.0547 1.31523 7.03125C1.31523 4.00781 3.77891 1.40625 7 1.40625C10.2211 1.40625 12.6875 4.00781 12.6875 7.03125C12.6875 8.28516 12.2746 9.44531 11.5609 10.3916Z",
    fill: "#454545"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstaCommentIcon);
export default __webpack_public_path__ + "static/media/InstaCommentIcon.c9141a7da91dbc0ee1be2ad3ebb53fb6.svg";
export { ForwardRef as ReactComponent };